module.exports = __webpack_public_path__ + "static/media/salad.2bcd1d20.jpeg";